<div class="container-fluid" xmlns="http://www.w3.org/1999/html">
  <div class="row header">
    <div class="col-xs-10 col-xs-offset-1 heading" style="letter-spacing: 1px;" >
      Check your Eligibility
    </div>
    <div class="col-xs-10 col-xs-offset-1 subheading">
      Here are a few details you need to provide to help us find the best loan options for you. Click here for
      <a (click)="scroll()" class="text-white font-bold">FAQs</a>
    </div>
  </div>

  <div class="row form-container">
    <form [formGroup]="checkEligibilityForm" (ngSubmit)="onSubmit(checkEligibilityForm)"
          class="col-xs-12 col-sm-10 col-sm-offset-1">

      <div *ngIf="!channelPartner.isAdvanceEmiPartner()">
          <mat-form-field class="input-field">
            <span matPrefix class="input-prefix">&#8377;</span>
            <input matInput placeholder="Required loan amount" type="number" formControlName="loanAmount"/>
            <mat-error>{{getErrorMessage(checkEligibilityForm.controls.loanAmount)}}</mat-error>
          </mat-form-field>
      </div>
      <div *ngIf="channelPartner.isAdvanceEmiPartner()">
            <mat-form-field class="input-field">
                <span matPrefix class="input-prefix">&#8377;</span>
                <input matInput placeholder="Loan amount" #requestedAmount type="number" formControlName="requestedAmount" (ngModelChange)="onRequestedAmountChanged(requestedAmount.value, checkEligibilityForm)"/>
                <mat-error>{{getErrorMessage(checkEligibilityForm.controls.requestedAmount)}}</mat-error>
            </mat-form-field>
      </div>

      <div *ngIf="channelPartner.isAdvanceEmiPartner()">
        <mat-form-field class="input-field">
          <mat-select #advanceEmiOption name="advanceEmiOption" formControlName="advanceEmiOption"
                      placeholder="Select number of EMIs"
                      required>
            <mat-option *ngFor="let advanceEmiOption of advanceEmiOptions" [value]="advanceEmiOption">{{advanceEmiOption.advanceEmiDisplayOption}}</mat-option>
          </mat-select>
          <mat-error>{{getErrorMessage(checkEligibilityForm.controls.advanceEmiOption)}}</mat-error>
        </mat-form-field>
      </div>

      <app-pan-validator class="input-field" (resetClearPhoneInfo)="onResetClearPhoneInfo()" (clearEligibilityCheckFormInfo)="onClearCheckEligibilityFormInfo()" (user)="onUser($event)"></app-pan-validator>

      <app-phone-validator class="input-field" [clearPhoneInfo] ="clearPhoneInfo" [mobileNumber]="mobileNumber"></app-phone-validator>

      <div formGroupName="income">
        <mat-form-field class="input-field">
          <mat-select #employeeType name="employeeType" formControlName="employeeType"
                      (selectionChange)="onEmployeeTypeChanged(employeeType.value, checkEligibilityForm)"
                      placeholder="Employment Type"
                      required>
            <mat-option [value]="EmployeeType.Salaried">Salaried</mat-option>
            <mat-option [value]="EmployeeType.SelfEmployed">Self Employed</mat-option>
          </mat-select>
          <mat-error>{{getErrorMessage(checkEligibilityForm.controls.income.controls.employeeType)}}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="!!checkEligibilityForm.controls.income.controls.employeeType.value"
                        class="input-field">
          <span matPrefix class="input-prefix">&#8377;</span>
          <input matInput
                 [placeholder]="checkEligibilityForm.controls.income.controls.employeeType.value === EmployeeType.Salaried ? 'Net monthly take home salary' : 'Annual income'"
                 type="number" formControlName="amount"/>
          <mat-error>{{getErrorMessage(checkEligibilityForm.controls.income.controls.amount)}}</mat-error>
        </mat-form-field>
      </div>

      <mat-form-field class="input-field">
        <span matPrefix class="input-prefix">&#8377;</span>
        <input matInput placeholder="Total EMI amount per month (if any)" formControlName="emi" type="number"/>
        <mat-error>{{getErrorMessage(checkEligibilityForm.controls.emi)}}</mat-error>
      </mat-form-field>

      <mat-form-field class="input-field">
        <span matPrefix class="input-prefix">&#8377;</span>
        <input matInput placeholder="Monthly rent paid (if any)" formControlName="rent" type="number"/>
        <mat-error>{{getErrorMessage(checkEligibilityForm.controls.rent)}}</mat-error>
      </mat-form-field>

      <mat-form-field>
        <input matInput [max]="maxDateOfBirth()" [min]="minDateOfBirth()" class="input-field" placeholder="Date of birth" (click)="picker.open()"
               [matDatepicker]="picker" formControlName="dateOfBirth" readonly/>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>{{getErrorMessage(checkEligibilityForm.controls.dateOfBirth)}}</mat-error>
      </mat-form-field>

      <mat-form-field class="input-field">
        <input type="number" matInput placeholder="PIN code" formControlName="pin" pattern="^[0-9]{6}$"/>
        <mat-error>{{getErrorMessage(checkEligibilityForm.controls.pin)}}</mat-error>
      </mat-form-field>

      <app-state-dropdown formControlName="state"
                          [errorMessage]="getErrorMessage(checkEligibilityForm.controls.state)"></app-state-dropdown>

      <app-city-dropdown formControlName="city" [formControlData]="checkEligibilityForm.controls.city"
                          [errorMessage]="getErrorMessage(checkEligibilityForm.controls.city)"></app-city-dropdown>

      <mat-checkbox #termsPartOne formControlName="termsPartOne"></mat-checkbox>
      <span id="terms">I agree to the <a target="_blank" routerLink="../../terms">Terms and conditions</a></span>
      <p class="consents">By clicking "Check Eligible Offers" you authorise finzy to obtain your credit information report(CIR)
        from Equifax to determine if you are eligible for any Indicative Loan Offers and you acknowledge that
        (i) this is not an application for a loan,
        (ii) identification of Indicative Loan Offers does not guarantee an approved loan offer.
        (iii) all the above information provided by you is correct, in-order for us to suggest the best loan options</p>

      <small>
        <mat-error *ngIf="((!termsPartOne.checked)
           && (checkEligibilityForm.controls['termsPartOne'].touched))">
          Please accept the terms to proceed
        </mat-error>
      </small>

      <small *ngIf="submissionError" class="submission-error">
        <mat-error>{{submissionError}}</mat-error>
      </small>

      <div class="text-end">
        <mat-spinner [diameter]="35" class="mat-spinner" *ngIf="loading"></mat-spinner>
        <button mat-flat-button *ngIf="!loading" [disabled]="checkEligibilityForm.invalid || !termsPartOne.checked || !userUtil.isUserLoggedIn() || !isUserOnline()"
                class="button-forward primary">
          Check Eligible Offers
        </button>
      </div>
    </form>
  </div>
</div>
